import { Headline, Text, TextButton } from '@oneaudi/unified-web-components';
import React from 'react';
import { SYS_SPACE_RELATIVE_2_XL, SYS_SPACE_RELATIVE_LG } from '@oneaudi/unified-web-common';

interface NavigationConfirmationProps {
  actionOnConfirm: () => void;
  translations: {
    confirmationHeadline: string;
    confirmationCopy: string;
    confirmationCtaLabel: string;
    confirmationCtaAriaLabel: string;
  };
}

export const NavigationConfirmation: React.FC<NavigationConfirmationProps> = ({
  actionOnConfirm,
  translations,
}) => {
  return (
    <>
      <Headline
        tag="h3"
        variant={{
          order: '3',
          weight: 'normal',
          type: 'headline',
        }}
        margin={[0, 0, SYS_SPACE_RELATIVE_LG, 0]}
      >
        {translations.confirmationHeadline}
      </Headline>

      <Text
        margin={[0, 0, SYS_SPACE_RELATIVE_2_XL, 0]}
        variant={{
          order: '1',
          style: 'normal',
          type: 'copy',
        }}
      >
        {translations.confirmationCopy}
      </Text>

      <TextButton
        aria-label={translations.confirmationCtaAriaLabel}
        iconPosition="leading"
        onClick={actionOnConfirm}
        size="md"
        type="button"
        variant="primary"
      >
        {translations.confirmationCtaLabel}
      </TextButton>
    </>
  );
};
